interface Action {
    payload: any,
    type: string
}

const CaseSubTypesReducer = (state = [], action: Action) => {
    switch (action.type) {
        case 'GET_CASE_SUB_TYPES':
            return action.payload;
        case 'RESET_CASE_SUB_TYPES':
            return [];
        default:
            return state;
    }
};

export default CaseSubTypesReducer;
